"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { mobileNavigation } from "./navigation";

export default function MobileNav() {
  const pathname = usePathname();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 h-16 bg-[#151719]/95 backdrop-blur border-t border-white/10 z-50">

      <div className="h-full grid grid-cols-4">

        {mobileNavigation.map((item) => {

          const active =
            pathname === item.href;

          return (
            <Link
              key={item.href}
              href={item.href}
              className={`flex flex-col items-center justify-center gap-0.5 transition ${
                active
                  ? "text-white"
                  : "text-gray-500"
              }`}
            >

              <span className="text-lg">
                {item.icon}
              </span>

              <span className="text-[10px]">
                {item.label === "File Transfer"
                  ? "Files"
                  : item.label}
              </span>

            </Link>
          );
        })}

      </div>

    </nav>
  );
}